import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'piqet-angular-module-header',
  templateUrl: './module-header.component.html',
  styleUrls: ['./module-header.component.css'],
})
export class ModuleHeaderComponent {
  activeRoute: any;
  @Input() headerData: any;
  @Input() gtStep: any;
  @Input() gtText: any;

  constructor(private route: ActivatedRoute) {
    this.activeRoute = location.href?.includes('/projects');
  }
}
